import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RestService } from 'src/app/service/rest.service';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.css']
})
export class NewsDetailsComponent implements OnInit {
  news_id
  new_data:any = {
    title : "",
    DETAILS : "",
    NEW_DATE : "",
    IMG_PATH : "",
    TITLE : ""
  }
  top_readed = []
  gallery: string[] = []
  keywords: string[] = []
  links: { url: string, title: string }[] = []
  videos: { url: SafeResourceUrl, title: string }[] = []
  src_image = ''
  constructor(private route: ActivatedRoute ,
    private router : Router,
     private rest : RestService,
     private seo : SeoService,
     private sanitizer : DomSanitizer ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.news_id = this.route.snapshot.paramMap.get('id')
    this.getData()
  }

  getData(){
    this.rest.newsDetails(this.news_id).subscribe((res:any) => {
      this.new_data = res.new_date
      this.setSeo(this.new_data)
      this.top_readed = res.top_readed
      // Extra attachment images returned by the API but never shown before.
      this.gallery = (res.NEW_IMGS || [])
        .map(img => img && img.ImageUrl)
        .filter(url => !!url)
      this.keywords = this.parseKeywords(res.NEW_KEY_WORDS)
      this.links = this.parseLinks(res.NEW_LINKS)
      this.videos = this.parseVideos(res.NEW_VIDEOS)
    })
  }

  // Feeds the loaded article into the SEO service so the tab title, meta
  // description and share (OG/Twitter) tags carry the real headline, summary
  // and image instead of the generic "تفاصيل الخبر" route title. Field names
  // are read defensively since the API casing isn't fully consistent.
  private setSeo(data: any) {
    this.seo.updateFrom(data)
  }

  // NEW_LINKS comes back as [{ LINK_URL, LINK_TITLE }]. Read the fields
  // defensively (the API naming isn't fully consistent) and drop empty rows.
  parseLinks(raw): { url: string, title: string }[] {
    return (Array.isArray(raw) ? raw : [])
      .map(it => {
        const url = this.pick(it, ['LINK_URL', 'URL', 'Link', 'link'])
        const title = this.pick(it, ['LINK_TITLE', 'TITLE', 'Title', 'title'])
        return { url, title: title || url }
      })
      .filter(l => !!l.url)
  }

  // NEW_VIDEOS holds embed/share links. Convert common watch/share URLs to their
  // embeddable form and mark them safe so they can be used as an <iframe> src.
  parseVideos(raw): { url: SafeResourceUrl, title: string }[] {
    return (Array.isArray(raw) ? raw : [])
      .map(it => {
        const rawUrl = (typeof it === 'string')
          ? it
          : this.pick(it, ['VIDEO_URL', 'EMBED_URL', 'EMBED', 'URL', 'VIDEO_LINK', 'LINK_URL', 'link', 'url'])
        const title = (typeof it === 'string')
          ? ''
          : this.pick(it, ['VIDEO_TITLE', 'TITLE', 'Title', 'title'])
        const embed = this.toEmbedUrl(rawUrl)
        return embed ? { url: this.sanitizer.bypassSecurityTrustResourceUrl(embed), title } : null
      })
      .filter(v => !!v)
  }

  // Returns the first non-empty value among the given keys.
  private pick(obj, keys: string[]): string {
    if (!obj) { return '' }
    for (const k of keys) {
      if (obj[k] != null && String(obj[k]).trim() !== '') { return String(obj[k]).trim() }
    }
    return ''
  }

  // Normalises a video URL into something an <iframe> can embed. Handles
  // YouTube (watch / youtu.be / shorts), Vimeo and Facebook; anything else
  // (e.g. an already-embeddable link) is passed through unchanged.
  private toEmbedUrl(url: string): string {
    if (!url) { return '' }
    const u = url.trim()

    // YouTube
    const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)
    if (yt) { return `https://www.youtube.com/embed/${yt[1]}` }

    // Vimeo
    const vimeo = u.match(/vimeo\.com\/(?:video\/)?(\d+)/)
    if (vimeo) { return `https://player.vimeo.com/video/${vimeo[1]}` }

    // Facebook (videos / reels / watch) — use the official video plugin.
    if (/facebook\.com|fb\.watch/.test(u) && !/plugins\/video\.php/.test(u)) {
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(u)}&show_text=false`
    }

    return u
  }

  // Opens the clicked gallery image in the lightbox modal.
  openImage(src) {
    this.src_image = src
  }

  // NEW_KEY_WORDS comes back as a list of objects whose tag_title is a (sometimes
  // malformed) JSON string holding "value" entries of dash-separated keywords.
  // Extract every value defensively with a regex, then split/clean/dedupe.
  parseKeywords(raw): string[] {
    if (!raw) { return [] }
    const items = Array.isArray(raw) ? raw : [raw]
    const set = new Set<string>()
    items.forEach(it => {
      const title = (it && it.tag_title != null) ? String(it.tag_title) : String(it)
      const matches = title.match(/"value"\s*:\s*"([^"]*)"/g) || []
      matches.forEach(m => {
        const value = m.replace(/"value"\s*:\s*"/, '').replace(/"$/, '')
        value.split(/\s*-\s*/).forEach(part => {
          const tag = part.trim()
          if (tag) { set.add(tag) }
        })
      })
    })
    return Array.from(set)
  }

  newsDetails(item){
    this.router.navigate(['/news_details',item.ID]).then(()=>{
      location.reload()
    })
  }
  go_to_news(){
    this.router.navigateByUrl('/news_list')
  }
}
